<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: 'app'
};
</script>

<style>
/* Add new fonts here */
@import '../node_modules/roboto-fontface/css/roboto/roboto-fontface.css';
@import '../node_modules/font-awesome/css/font-awesome.css';
@import '../node_modules/material-design-icons/iconfont/material-icons.css';
@import '../node_modules/source-sans-pro/source-sans-pro.css';
@import '../node_modules/npm-font-open-sans/open-sans.css';
@import '../node_modules/npm-font-open-sans-condensed/open-sans-condensed.css';
@import '../node_modules/raleway-webfont/raleway.css';

@font-face {
  font-family: 'Libre Baskerville';
  src: url('assets/fonts/LibreBaskerville-Regular.ttf') format('truetype');
  font-style: normal;
  font-weight: 400;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Libre Baskerville';
  src: url('assets/fonts/LibreBaskerville-Bold.ttf') format('truetype');
  font-style: normal;
  font-weight: 700;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Brown';
  src: url('assets/fonts/Brown-Light.ttf') format('truetype');
  font-style: normal;
  font-weight: 300;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Brown';
  src: url('assets/fonts/Brown-Regular.ttf') format('truetype');
  font-style: normal;
  font-weight: 400;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Brown';
  src: url('assets/fonts/Brown-Bold.ttf') format('truetype');
  font-style: normal;
  font-weight: 800;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Noto Sans Arabic';
  src: url('assets/fonts/NotoSansArabic-Regular.ttf') format('truetype');
  font-style: normal;
  font-weight: 400;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Noto Sans Arabic';
  src: url('assets/fonts/NotoSansArabic-Medium.ttf') format('truetype');
  font-style: normal;
  font-weight: 500;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'Noto Sans Arabic';
  src: url('assets/fonts/NotoSansArabic-Bold.ttf') format('truetype');
  font-style: normal;
  font-weight: 700;
  text-rendering: optimizeLegibility;
}

body {
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}

.loading {
  display: grid;
  align-items: center;
  width: 100vw;
  height: 100vh;
  text-align: center;
}

.errored {
  display: grid;
  align-items: center;
  width: 100vw;
  height: 100vh;
  text-align: center;
  color: red;
}
</style>
